import { makeStyles } from '@fluentui/react';

export const useStyles = makeStyles((theme) => ({

  dropdownStyles: {
    border: 0,
    width: 350,
  },
  textInputStyle: {
    width: 350,
  },
  width100: {
    width: 100,
  },
}));
